module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.99682a78.ttf";